export default "<p>\r\n  machineproperty works!\r\n</p>\r\n"